import macro from '@kitware/vtk.js/macros.js';
import vtkOpenGLRenderWindow from '@kitware/vtk.js/Rendering/OpenGL/RenderWindow.js';
import vtkStreamingOpenGLViewNodeFactory, { registerOverride, } from './vtkStreamingOpenGLViewNodeFactory.js';
function vtkStreamingOpenGLRenderWindow(publicAPI, model) {
    model.classHierarchy.push('vtkStreamingOpenGLRenderWindow');
}
export function extend(publicAPI, model, initialValues = {}) {
    Object.assign(model, initialValues);
    vtkOpenGLRenderWindow.extend(publicAPI, model, initialValues);
    model.myFactory = vtkStreamingOpenGLViewNodeFactory.newInstance();
    registerOverride('vtkRenderWindow', newInstance);
    vtkStreamingOpenGLRenderWindow(publicAPI, model);
}
export const newInstance = macro.newInstance(extend, 'vtkStreamingOpenGLRenderWindow');
export default { newInstance, extend };
